import angular from 'angular'
import UsersList from './UsersList.vue'
import TabbedUsersPage from './TabbedUsersPage'

export default angular
  .module('adminPanel.users', [])
  .value(UsersList.name, UsersList)
  .value(TabbedUsersPage.name, TabbedUsersPage)
